<script lang="ts">
	import type { GuideSection } from '$lib/content/marketplace-seo';
	import { localizeHref } from '@/paraglide/runtime';

	interface Props {
		sections: GuideSection[];
	}

	let { sections }: Props = $props();
</script>

<section aria-label="Guía de alquiler de barcos" class="space-y-10">
	{#each sections as section (section.id)}
		<article class="space-y-3">
			<h2 class="text-lg font-semibold tracking-tight md:text-xl">{section.title}</h2>
			<div class="text-muted-foreground space-y-3 text-sm leading-relaxed md:text-base">
				{#each section.paragraphs as paragraph, i (i)}
					<p>{paragraph}</p>
				{/each}
			</div>
			{#if section.links && section.links.length > 0}
				<ul class="flex flex-wrap gap-2 pt-1">
					{#each section.links as link (link.href)}
						<li>
							<a
								href={localizeHref(link.href)}
								class="text-primary inline-flex rounded-full border px-3 py-1 text-xs font-medium transition-colors hover:bg-accent md:text-sm"
							>
								{link.label}
							</a>
						</li>
					{/each}
				</ul>
			{/if}
		</article>
	{/each}
</section>
